import JSX from "../../helpers/react.js";
import {filterExpand} from "./FilterExpand.js";
import {FilterBlock} from "./FilterBlock.js";

function showFilter(appendTo: HTMLElement, btn: HTMLDivElement) {
    const pathName = new URL(location.href).pathname;
    const isUsers = pathName === '/users' || pathName === '/users/' || pathName === '/users/filter' || pathName === '/users/filter/';
    // const $element = $('.filter-content')
    //     // .text('')
    //     .each((_, el) =>{
    let el: any;
    if (!(el = appendTo.querySelector('.filter-block'))) {
        appendTo.appendChild(el = <FilterBlock isUsers={isUsers}/>);

        $(appendTo)
            .find('select')
            .slimSelect();

    }
    el.style.width = Math.max(btn.clientWidth + 1, 280) + "px"
    setTimeout(() => el.classList.add('shown'));

    if (!isUsers) {
        let filterPos = localStorage.filterSwitch;
        if (filterPos === 'true') {
            $('.filter-switch .switch').addClass('active');
            $('.filter-block').removeClass('main');
            filterExpand();
        }
    }
}

async function hideFilter(parent: HTMLElement) {
    const el = parent.querySelector(".filter-block");
    el!.classList.remove('shown');
    // await new Promise(r=>setTimeout(r, 400));
}

$('html').on('click', '.filter-btn', function (this: HTMLDivElement) {
    if (this.parentElement!.querySelector(".filter-block")?.classList?.contains('shown'))
        return hideFilter(this.parentElement!);
    showFilter(this.parentElement!, this);
})
$(function () {
    const pathname = location.pathname;
    const urlSearchParams = new URLSearchParams(location.search);
    if (pathname.startsWith("/catalog/filter") || pathname.startsWith('/users/filter') || pathname === '/users' || pathname === '/users/' || urlSearchParams.has('show_filter')) {
        const el = $('.filter-btn');
        showFilter(el[0].parentElement!, el[0] as HTMLDivElement);
    }
})